import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

interface MailChimpResponse {
	result: string;
	msg: string;
}

@Component({
	selector: 'ras-ebook-get-more-space-page',
	templateUrl: './ebook-get-more-space-page.component.html',
	styleUrls: ['./ebook-get-more-space-page.component.sass']
})
export class EbookGetMoreSpacePageComponent implements OnInit {

	public captcha_correct: boolean = false
	public submitted: boolean = false
	public show_invalid: boolean = false
	public submitting: boolean = false

	public first_name: string = ""
	public last_name: string = ""
	public email: string = ""
	public phone: string = ""

	@ViewChild('form') form

	constructor(private ref: ChangeDetectorRef, private http: HttpClient) { }

	ngOnInit(): void {
	}

	captcha_success() {
		this.captcha_correct = true
		this.ref.detectChanges()
	}

	submit() {
		this.show_invalid = true
		let valid = this.form.nativeElement.checkValidity()
		if (valid && !this.submitting) {
			this.submitting = true

			if ((<any>window).dataLayer) (<any>window).dataLayer.push({
				'event': 'formSubmission',
				'formType': 'Download eBook',
				'formId': 'get-more-space'
			});

			const params = new HttpParams()
			.set('FNAME', this.first_name)
			.set('LNAME', this.last_name)
			.set('EMAIL', this.email)
			.set('PHONE', this.phone)
			.set('b_a696f656183195751e2c27e61_cc10e9d1e1', '')

			// const mailchimp_url = 'https://rentastore.us13.list-manage.com/subscribe/post-json?u=a696f656183195751e2c27e61&id=cc10e9d1e1&' + params.toString()
			const mailchimp_url = 'https://rentastore.us13.list-manage.com/subscribe/post-json?u=a696f656183195751e2c27e61&id=eed9c4afed&f_id=000858e3f0&' + params.toString()

			let subscription = this.http.jsonp<MailChimpResponse>(mailchimp_url, 'c')
			.subscribe(response => {
				if (response.result && response.result !== 'error') {
				}
				else {
					console.error("mailchimp error response", response);
				}
				this.submitted = true
				subscription.unsubscribe()
			}, error => {
				this.submitted = true
				subscription.unsubscribe()
				console.error("mailchimp error", error);
			});
		}
	}

}
